import AnthropicIcon from './claude-color.svg?react'
import DeepSeekIcon from './deepseek-color.svg?react'
import GeminiIcon from './gemini-color.svg?react'
import GrokIcon from './grok.svg?react'
import MinimaxIcon from './minimax-color.svg?react'
import MoonshotIcon from './moonshot.svg?react'
import OpenAIIcon from './openai.svg?react'
import QwenIcon from './qwen-color.svg?react'
import ZAIIcon from './zai.svg?react'
import XiaomiMinioIcon from './xiaomimimo.svg?react'
import StepFunIcon from './stepfun-color.svg?react'
import BytedanceIcon from './bytedance-color.svg?react'
import KlingIcon from './kling-color.svg?react'
import type { ModelFamily } from '../../../../../shared-pricing-config'
import type { GenerationModelFamily } from '../../../../../shared-generation-pricing-config'

interface ModelFamilyIconProps {
  modelFamily: ModelFamily | GenerationModelFamily
  size?: number
  className?: string
}

export function ModelFamilyIcon({
  modelFamily,
  size = 32,
  className = '',
}: ModelFamilyIconProps) {
  const iconProps = {
    width: size,
    height: size,
    className,
  }

  switch (modelFamily) {
    case 'openai':
      return <OpenAIIcon {...iconProps} />
    case 'moonshot':
      return <MoonshotIcon {...iconProps} />
    case 'anthropic':
      return <AnthropicIcon {...iconProps} />
    case 'deepseek':
      return <DeepSeekIcon {...iconProps} />
    case 'google':
      return <GeminiIcon {...iconProps} />
    case 'xai':
    case 'grok':
      return <GrokIcon {...iconProps} />
    case 'minimax':
      return <MinimaxIcon {...iconProps} />
    case 'qwen':
    case 'wan':
      return <QwenIcon {...iconProps} />
    case 'zai':
      return <ZAIIcon {...iconProps} />
    case 'xiaomi':
      return <XiaomiMinioIcon {...iconProps} />
    case 'stepfun':
      return <StepFunIcon {...iconProps} />
    case 'bytedance':
      return <BytedanceIcon {...iconProps} />
    case 'kling':
      return <KlingIcon {...iconProps} />
    case 'replicate':
    case 'stability':
    case 'unknown':
    default:
      return null
  }
}
